import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import SwiperCore, {
  FreeMode,
  Navigation,
  Pagination,
  SwiperOptions,
  Thumbs,
} from "swiper";
// install Swiper modules
SwiperCore.use([FreeMode, Navigation, Thumbs, Pagination]);

@Component({
  selector: "app-categories-slider",
  templateUrl: "./categories-slider.component.html",
  styleUrls: ["./categories-slider.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CategoriesSliderComponent implements OnInit {
  @Input() itemsList: any[] = [];
  @Input() itemsListDesktop: any[] = [];
  thumbsSwiper: any;
  

  servicesUrlimage = this.commonService._ImageUrl + "services/";
  brandUrlimage = this.commonService._ImageUrl + 'trademarks/';

  categoriesSliderConfig: SwiperOptions = {
    slidesPerView: "auto",
    spaceBetween: 10,
    loop: false,
    // navigation: true,

    scrollbar: { draggable: true },
  };

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {

    // setTimeout(() => {
    //   const slicedArray1 = this.itemsListDesktop.slice(0,4);
    //   this.itemsListDesktop = slicedArray1;
    // }, 1000);

    
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // //console.log('categorty slider items list ', this.itemsList);
    
  }
  
}
